const responsiveImageStyles = {
  article_card: {
    default: {
      article_card_tablet: '389x291',
    },
    mobile: {
      x1: {
        article_card_mobile: '720x540',
      },
    },
    tablet: {
      x1: {
        article_card_tablet: '389x291',
      },
    },
  },
  article_inspiration_small: {
    default: {
      article_inspiration_small_desktop: '360x239',
    },
    mobile: {
      x1: {
        article_inspiration_small_mobile: '720x479',
      },
    },
    tablet: {
      x1: {
        article_inspiration_small_tablet: '423x282',
      },
    },
    desktop: {
      x1: {
        article_inspiration_small_desktop: '360x239',
      },
    },
  },
  article_inspiration_big: {
    default: {
      article_inspiration_big_desktop: '755x506',
    },
    mobile: {
      x1: {
        article_inspiration_small_mobile: '720x479',
      },
    },
    tablet: {
      x1: {
        article_inspiration_big_tablet: '727x581',
      },
    },
    desktop: {
      x1: {
        article_inspiration_big_desktop: '755x506',
      },
    },
  },
  search_card: {
    default: {
      search_card_tablet: '208x156',
    },
    mobile: {
      x1: {
        search_card_mobile: '720x479',
      },
    },
    tablet: {
      x1: {
        search_card_tablet: '208x156',
      },
    },
  },
  gallery: {
    default: {
      gallery_desktop: '1200x800',
    },
    mobile: {
      x1: {
        gallery_react_mobile: '960x640',
      },
    },
    mobile_small: {
      x1: {
        gallery_react_mobile_small: '480x320',
      },
    },
    tablet: {
      x1: {
        gallery_react_tablet: '1200x800',
      },
    },
    desktop: {
      x1: {
        gallery_react_mobile: '960x640',
      },
    },
  },
  gallery_thumbs: {
    default: {
      gallery_thumbnail_tablet_x2: '342x258',
    },
    tablet: {
      x1: {
        gallery_thumbnail_tablet: '171x129',
      },
    },
    desktop: {
      x1: {
        gallery_thumbnail_desktop: '132x92',
      },
    },
  },
  gallery_modal: {
    default: {
      gallery_modal_desktop: '1610x1074',
    },
    mobile: {
      x1: {
        gallery_modal_mobile: '1367x912',
      },
    },
    smallMobile: {
      x1: {
        gallery_modal_mobile_small: '1080x720',
      },
    },
    tablet: {
      x1: {
        gallery_modal_tablet: '1610x1074',
      },
    },
    desktop: {
      x1: {
        gallery_modal_desktop: '1610x1074',
      },
    },
  },
  gallery_modal_thumbnail: {
    default: {
      gallery_modal_thumbnail_desktop: '294x221',
    },
    mobile: {
      x1: {
        gallery_modal_thumbnail_mobile: '128x137',
      },
    },
    smallMobile: {
      x1: {
        gallery_modal_thumbnail_mobile_small: '86x65',
      },
    },
    tablet: {
      x1: {
        gallery_modal_thumbnail_tablet: '240x180',
      },
    },
    desktop: {
      x1: {
        gallery_modal_thumbnail_desktop: '294x221',
      },
    },
  },
  product_document_card: {
    default: {
      search_card_tablet: '120x120',
    },
    mobile: {
      x1: {
        search_card_mobile: '67x67',
      },
    },
    tablet: {
      x1: {
        search_card_tablet: '112x112',
      },
    },
    desktop: {
      x1: {
        gallery_modal_thumbnail_desktop: '120x120',
      },
    },
  },
  contractor_card: {
    default: {
      contractor_card_tablet: '163x163',
    },
    mobile: {
      x1: {
        contractor_card_mobile: '72x72',
      },
    },
    tablet: {
      x1: {
        contractor_card_tablet: '163x163',
      },
    },
  },
  chip_thumbnail: {
    default: {
      chip_thumbnail: '200x200',
    },
    mobile: {
      x1: {
        chip_thumbnail: '200x200',
      },
    },
  },
  chip_media: {
    default: {
      chip_media: '754x754',
    },
    mobile: {
      x1: {
        chip_media_mobile: '480x480',
      },
    },
    tablet: {
      x1: {
        chip_media: '754x754',
      },
    },
  },
  cover_flow_portrait: {
    default: {
      cover_flow_portrait_desktop: '510x786',
    },
    mobile: {
      x1: {
        cover_flow_portrait_mobile: '768x768',
      },
    },
    tablet: {
      x1: {
        cover_flow_portrait_tablet: '339x510',
      },
    },
    desktop: {
      x1: {
        cover_flow_portrait_desktop: '510x786',
      },
    },
  },
  cover_flow_landscape: {
    default: {
      cover_flow_landscape_desktop: '1440x810',
    },
    mobile: {
      x1: {
        cover_flow_landscape_mobile: '768x432',
      },
    },
    tablet: {
      x1: {
        cover_flow_landscape_tablet: '1280x720',
      },
    },
    desktop: {
      x1: {
        cover_flow_landscape_desktop: '1440x810',
      },
    },
  },
};

export default responsiveImageStyles;
